import api from "@/Services/ApiService";

export default {
  async register(input) {
    const res = await api.external({
      path: `/auth/register`,
      method: "post",
      input,
    });
    return res;
  }
};